import React, { useState } from 'react';
import { CgFileDocument } from 'react-icons/cg';
import { FaCheck } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { downloadInvoiceAction } from '../../redux/actions/visitActions';
import Button from '../shared/buttons/Button';
import CompleteVisitModal from './modals/CompleteVisitModal';

const VisitActions = ({ readOnly }) => {
  const dispatch = useDispatch();
  const { vin, id } = useSelector((state) => state.visit.visit);
  const visitTasks = useSelector((state) => state.visitTasks.visitTasks);
  const visitParts = useSelector((state) => state.visitParts.visitParts);
  const [showCompleteModal, setShowCompleteModal] = useState(false);

  return (
    <div className="flex items-center w-fit gap-2">
      {showCompleteModal && <CompleteVisitModal onModalClose={() => setShowCompleteModal(false)} />}
      {(visitTasks.length !== 0 || visitParts.length !== 0) && (
        <>
          {!readOnly && (
            <Button
              variant={'primary'}
              onClick={() => {
                setShowCompleteModal(true);
              }}
            >
              <FaCheck />
              Завершити
            </Button>
          )}
          <Button
            variant={'danger'}
            onClick={() => {
              dispatch(downloadInvoiceAction(vin, id));
            }}
          >
            <CgFileDocument />
            Рахунок
          </Button>
        </>
      )}
    </div>
  );
};

export default VisitActions;
